export default __webpack_public_path__ + "static/media/join-us.efda18bb.jpg";